import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/solid";

const Pagination = ({ page, disableNext, disablePrev, handleNext, handlePrev, total }) => {
  return (
    <div className="flex items-center">
      <button
        type="button"
        disabled={disablePrev}
        onClick={() => handlePrev(page - 1)}
        className="secondary-button p-0.5"
      >
        <ChevronLeftIcon className="h-5 w-5" />
      </button>
      <span className="mx-4 text-gray-500 text-lg">
        {page}
        {!!total && ` of ${total}`}
      </span>
      <button
        type="button"
        disabled={disableNext}
        onClick={() => handleNext(page + 1)}
        className="secondary-button p-0.5"
      >
        <ChevronRightIcon className="h-5 w-5" />
      </button>
    </div>
  );
};

export default Pagination;
